const BOARD_BUNDLE_PATH_PATTERN = /\/dist\/(react\/sportV2-[a-f0-9]+\.js)$/i;

const getBoardBundlePathFromScriptSources = (sources = []) => {
  for (const source of Array.isArray(sources) ? sources : []) {
    const path = String(source || "").split("?")[0];
    const match = path.match(BOARD_BUNDLE_PATH_PATTERN);
    if (match) {
      return match[1];
    }
  }

  return "";
};

const getBoardBundlePathFromManifest = (manifest = {}) => {
  if (!manifest || typeof manifest !== "object" || Array.isArray(manifest)) {
    return "";
  }

  return String(manifest["sportV2.js"] || "").replace(/^\/+/, "");
};

const boardBundleIsOutdated = (scriptSources, manifest) => {
  const currentPath = getBoardBundlePathFromScriptSources(scriptSources);
  const expectedPath = getBoardBundlePathFromManifest(manifest);

  return Boolean(currentPath && expectedPath && currentPath !== expectedPath);
};

module.exports = {
  boardBundleIsOutdated,
  getBoardBundlePathFromManifest,
  getBoardBundlePathFromScriptSources,
};
